import { Directive, ElementRef, HostListener, Input } from "@angular/core";
import { Plugin } from "@webapp/plugins/plugins.models";

@Directive({
  selector: "[pluginOnLoad]",
})
export class PluginOnLoadDirective {
  @Input() public plugin: Plugin;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  @HostListener("load")
  public setSandboxAttribute(): void {
    const element = this.elementRef.nativeElement;

    if (this.plugin?.uiPlugin.featurePolicy) {
      element.setAttribute("sandbox", this.plugin.uiPlugin.featurePolicy);
    }
  }
}
